<template>
  <v-card flat>
    <v-toolbar flat color="primary" dark>
      <v-toolbar-title>Context Permissions</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon v-if="!needsSaving.any && !inviting" @click="clearModal"
        ><v-icon>close</v-icon></v-btn
      >
    </v-toolbar>
    <v-card-text>
      <v-list rounded>
        <v-list-item-group v-model="settings" mandatory>
          <v-list-item value="public">
            <template v-slot:default="{ active, toggle }">
              <v-list-item-action>
                <v-switch color="primary" v-model="active" @click="toggle" class="ma-2"></v-switch>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Public</v-list-item-title>
                <v-list-item-subtitle>
                  Allow anyone to search for, view and evaluate this context.
                </v-list-item-subtitle>
              </v-list-item-content>
            </template>
          </v-list-item>
          <v-list-item value="publicView">
            <template v-slot:default="{ active, toggle }">
              <v-list-item-action>
                <v-switch color="primary" v-model="active" @click="toggle" class="ma-2"></v-switch>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Viewing Link</v-list-item-title>
                <v-list-item-subtitle>
                  Allow anyone with this link to view this context.
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action v-if="active">
                <textarea
                  style="position: absolute; opacity: 0;"
                  id="publicLink"
                  :value="`https://context-v5.web.app${$route.fullPath}`"
                ></textarea>
                <v-btn x-small text class="grey--text" @click="copyUrl">
                  <v-icon small class="pr-2">file_copy</v-icon> Copy Link
                </v-btn>
              </v-list-item-action>
            </template>
          </v-list-item>
          <v-list-item value="private">
            <template v-slot:default="{ active, toggle }">
              <v-list-item-action>
                <v-switch color="primary" v-model="active" @click="toggle" class="ma-2"></v-switch>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Private</v-list-item-title>
                <v-list-item-subtitle>
                  Only people, groups or teams explicitly given permission can see or evaluate this
                  context.
                </v-list-item-subtitle>
              </v-list-item-content>
            </template>
          </v-list-item>
        </v-list-item-group>
      </v-list>
      <v-toolbar flat dense>
        <v-toolbar-title>WHO HAS ACCESS</v-toolbar-title>
      </v-toolbar>
      <v-list dense hover>
        <v-list-item v-if="workspace.status !== 'fetching'" class="grey lighten-5">
          <v-list-item-avatar size="30">
            <v-img v-if="workspaceProfile.avatar" :src="workspaceProfile.avatar"></v-img>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title
              >{{ workspaceProfile.name }}
              <span class="caption">(The entire workspace)</span></v-list-item-title
            >
          </v-list-item-content>
          <v-list-item-action>
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn
                  color="primary"
                  text
                  v-on="on"
                  v-text="getUserPermission(workspaceProfile.id)"
                ></v-btn>
              </template>
              <v-list>
                <v-list-item @click="setUserPermission({ userId: workspaceProfile.id, value: 'editing' })">
                  <v-list-item-title>Can Edit</v-list-item-title>
                </v-list-item>
                <v-list-item
                  @click="setUserPermission({ userId: workspaceProfile.id, value: 'commenting' })"
                >
                  <v-list-item-title>Can Comment</v-list-item-title>
                </v-list-item>
                <v-list-item @click="setUserPermission({ userId: workspaceProfile.id, value: 'viewing' })">
                  <v-list-item-title>Can View</v-list-item-title>
                </v-list-item>
                <v-list-item @click="setUserPermission({ userId: workspaceProfile.id, value: 'hidden' })">
                  <v-list-item-title>Hidden</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-list-item-action>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item
          v-for="member in permissionDirectory.filter(d => d.id !== item.workspace)"
          :key="member.id"
          rounded
          :style="getUserPermission(member.id) == 'usersToRemove' ? 'opacity: 0.4' : ''"
          :class="{ grey: member.status == 'fetching' }"
        >
          <template v-if="member.status !== 'fetching'">
            <v-list-item-avatar size="30">
              <v-img :src="member.avatar"></v-img>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title v-text="member.name"></v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
              <v-btn v-if="getUserPermission(member.id) == 'usersToRemove'" text disabled
                >REMOVED</v-btn
              >
               <v-btn v-else-if="member.id == item.permissions.owner" small text>
                Owner
              </v-btn>
              <v-menu offset-y v-else>
                <template v-slot:activator="{ on }">
                  <v-btn
                    color="primary"
                    text
                    v-on="on"
                    v-text="getUserPermission(member.id)"
                  ></v-btn>
                </template>
                <v-list>
                  <v-list-item @click="setUserPermission({ userId: member.id, value: 'editing' })">
                    <v-list-item-title>Can Edit</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    @click="setUserPermission({ userId: member.id, value: 'commenting' })"
                  >
                    <v-list-item-title>Can Comment</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="setUserPermission({ userId: member.id, value: 'viewing' })">
                    <v-list-item-title>Can View</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-list-item-action>
            <v-list-item-action v-if="getUserPermission(member.id) != 'usersToRemove'">
              <v-btn icon small @click="removeUser(member.id)">
                <v-icon small>close</v-icon>
              </v-btn>
            </v-list-item-action>
          </template>
        </v-list-item>
      </v-list>
      <invite-users-form
        v-if="!needsSaving.any"
        :typeAheadList="collaborators"
        :dropDownList="workspaceMembers"
        actionLabel="Invite"
        title="Add Users or Groups"
        label="Enter names or email addresses"
        @inviteUsers="inviteUsers"
        @inviting="inviting = true"
        @notInviting="inviting = false"
      ></invite-users-form>
      <v-alert v-else color="grey lighten-2">You have changes that need to be saved.</v-alert>
    </v-card-text>
    <v-card-actions>
      <v-btn v-if="!needsSaving.any && !inviting" @click="clearModal">Done</v-btn>
      <template v-else-if="needsSaving.any">
        <v-btn @click="save" color="primary">Save</v-btn>
        <v-btn @click="resetValues">Cancel</v-btn>
      </template>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
import InviteUsersForm from '@/components/SettingsModal/InviteUsersForm';

export default {
  props: ['item'],
  components: { InviteUsersForm },
  data() {
    return {
      usersToRemove: [],
      inviting: false,
      usersNotSignedUp: [],
      editing: [],
      viewing: [],
      commenting: []
      //permissionDirectory: []
    };
  },
  mounted() {
    //this.buildPermissionDirectory();
    this.resetValues();
  },
  computed: {
    ...mapGetters('workspaces', ['workspaces', 'collaboratorDirectory']),
    ...mapGetters('auth', ['userId']),
    workspace() {
      console.log('get workspace');
      const workspace =
        this.workspaces.find(w => w.id == this.item.workspace) ||
        this.permissionDirectory.find(w => w.id == this.item.workspace);
      return workspace || { status: 'fetching' };
    },
    workspaceProfile() {
      let profile;
      if (this.workspace.profile) {
        profile = Object.assign({}, this.workspace.profile);
        profile.id = this.workspace.id;
      } else {
        profile = this.permissionDirectory.find(w => w.id == this.item.workspace);
      }
      return profile || { id: this.item.workspace, status: 'fetching' };
    },
    settings: {
      get() {
        return this.item.permissions.visibility;
      },
      set(v) {
        console.log(v);
        this.updateContextPermissionsField({
          contextId: this.item.id,
          fieldKey: 'visibility',
          fieldValue: v
        });
      }
    },
    needsSaving() {
      const { editing, viewing, commenting } = this.item.permissions;
      const same = function(a, b) {
        return (
          a
            .slice()
            .sort()
            .toString() ===
          b
            .slice()
            .sort()
            .toString()
        );
      };
      const returnObject = {
        any:
          !!this.usersToRemove.length ||
          !same(this.editing, editing) ||
          !same(this.viewing, viewing) ||
          !same(this.commenting, commenting),
        editing: !same(this.editing, editing),
        viewing: !same(this.viewing, viewing),
        commenting: !same(this.commenting, commenting)
      };
      console.log('needsSaving', returnObject);
      return returnObject;
    },
    permissionIds() {
      try {
        console.log('get permission ids');
        const { editing, viewing, commenting } = this.item.permissions;
        const result = commenting.concat(editing, viewing);
        return result;
      } catch (e) {
        return [];
      }
    },
    workspaceMembers() {
      try {
        const members = this.workspace.members;
        const collabs = Object.values(members).filter(m => {
          return !this.permissionIds.includes(m.id) && m.id != this.userId;
        });
        return collabs;
      } catch (e) {
        return [];
      }
    },
    collaborators() {
      const collabs = Object.values(this.collaboratorDirectory).filter(m => {
        return !this.permissionIds.includes(m.id) && m.id != this.userId;
      });
      return collabs;
    },
    permissionDirectory() {
      console.log('build permission directory');
      //  Built a result array that includes workspaces
      const profilesToFetch = [];
      const directory = [];
      //  Owner
      const owner = this.collaboratorDirectory[this.item.permissions.owner];
      if (owner) {
        directory.push(owner);
      } else {
        directory.push({ id: this.item.permissions.owner, status: 'fetching' });
        profilesToFetch.push(this.item.permissions.owner);
      }
      const collaboratorDirectory = this.collaboratorDirectory;
      this.permissionIds.forEach(p => {
        const user = collaboratorDirectory[p];
        if (user) {
          directory.push(user);
        } else {
          console.log('no user');
          directory.push({ id: p, status: 'fetching' });
          profilesToFetch.push(p);
        }
        if (profilesToFetch.length) {
          //  fetch profiles
          console.log('fetch profiles');
          this.fetchProfiles(profilesToFetch);
        }
      });
      return directory; //.sort((a, b) => a.name > b.name);
    }
  },
  methods: {
    ...mapMutations('components/settingsModal', ['clearModal']),
    ...mapActions('context', ['updateContextPermissionsField']),
    ...mapActions('workspaces', ['fetchGuestProfiles', 'addProfilesToGuestMemberProfiles']),
    resetValues() {
      const { editing, viewing, commenting } = this.item.permissions;
      this.editing = editing.slice(0);
      this.viewing = viewing.slice(0);
      this.commenting = commenting.slice(0);
      this.usersToRemove = [];
    },
    fetchProfiles(profilesToFetch) {
      console.log('fetch profiles');
      this.fetchGuestProfiles({
        userIds: profilesToFetch,
        workspaceId: this.item.workspace
      })
        .then(guestProfiles => {
          this.addProfilesToGuestMemberProfiles({ profileArray: guestProfiles });
        })
        .catch(e => console.log(e));
    },
    // buildPermissionDirectory() {
    //   //  Built a result array that includes workspaces
    //   const profilesToFetch = [];
    //   this.permissionIds.forEach(async p => {
    //     const user = this.collaboratorDirectory[p];
    //     if (user) {
    //       this.permissionDirectory.push(user);
    //     } else {
    //       this.permissionDirectory.push({ id: p, status: 'fetching' });
    //       profilesToFetch.push(p);
    //     }
    //     if (profilesToFetch.length) {
    //       //  fetch profiles
    //       try {
    //         const guestProfiles = await this.fetchGuestProfiles({
    //           userIds: profilesToFetch,
    //           workspaceId: this.item.workspace
    //         });
    //         //  Add to vuex so we don't have to load
    //         this.addProfilesToGuestMemberProfiles({ profileArray: guestProfiles });

    //         //  Update permissionDirectory with new stuff
    //         guestProfiles.forEach(g => {
    //           const index = this.permissionDirectory.findIndex(d => d.id == g.id);
    //           this.permissionDirectory[index] = g;
    //         });
    //       } catch (e) {
    //         console.log(e);
    //       }
    //     }
    //   });
    //   //return result.sort((a, b) => a.name > b.name);
    // },
    inviteUsers(users) {
      console.log(users);
      //const editing = this.editing;
      //editing.concat(users.map(u => u.id));
      const value = users.map(u => u.id);
      //console.log(editing);
      this.updateContextPermissionsField({
        contextId: this.item.id,
        fieldKey: 'editing',
        fieldValue: value
      });
      //  manually add profile to vuex and component

      this.$nextTick(() => {
        //  Update this.editing array to match item.permissions
        this.editing = this.item.permissions.editing;
      });
    },
    getUserPermission(userId) {
      const options = ['usersToRemove', 'editing', 'commenting', 'viewing'];
      const result = options.find(o => this[o].includes(userId));
      return result ? result : 'hidden';
    },
    setUserPermission({ userId, value }) {
      const oldValue = this.getUserPermission(userId);
      if (oldValue != 'hidden') {
        //  remove from old value
        this[oldValue] = this[oldValue].filter(o => o != userId);
      }
      //  add to new value
      if (value != 'hidden') {
        this[value].push(userId);
      }
    },
    copyUrl() {
      const copyText = document.getElementById('publicLink');
      copyText.select();
      document.execCommand('copy');
      console.log('copied');
    },
    removeUser(userId) {
      const from = this.getUserPermission(userId);
      this[from] = this[from].filter(u => u != userId);
      this.usersToRemove.push(userId);
    },
    save() {
      const needsSaving = JSON.parse(JSON.stringify(this.needsSaving));
      console.log('needsSaving', needsSaving);
      if (needsSaving.editing) {
        this.updateContextPermissionsField({
          contextId: this.item.id,
          fieldKey: 'editing',
          fieldValue: this.editing
        });
      }
      if (needsSaving.viewing) {
        this.updateContextPermissionsField({
          contextId: this.item.id,
          fieldKey: 'viewing',
          fieldValue: this.viewing
        });
      }
      if (needsSaving.commenting) {
        this.updateContextPermissionsField({
          contextId: this.item.id,
          fieldKey: 'commenting',
          fieldValue: this.commenting
        });
      }
      this.usersToRemove = [];
    }
  }
};
</script>

<style></style>
